/* import __COLOCATED_TEMPLATE__ from './column-dropdown-market.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import ColumnDropdown from '@dashboard/shared-ui/components/column-dropdown';
import { action } from '@ember/object';
let ColumnDropdownMarket = (_class = class ColumnDropdownMarket extends ColumnDropdown {
  optionDidChange(column, selected) {
    if (selected) {
      this.columnsSelected.addObject(column);
    } else {
      this.columnsSelected.removeObject(column);
    }
    this.optionsDidChange();
  }
}, _applyDecoratedDescriptor(_class.prototype, "optionDidChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "optionDidChange"), _class.prototype), _class);
export { ColumnDropdownMarket as default };